import React from 'react';
export function Footer() {
  return <footer className="bg-black border-t border-gray-900 py-8 px-4 text-center" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <div className="inline-flex items-center gap-2 text-green-400 font-bold text-xl mb-4" data-id="element-160">
          <span data-id="element-161">🤖</span> TU MANUAL DIGITAL™
        </div>

        <p className="text-gray-400 mb-6 max-w-md mx-auto" data-id="element-162">
          El sistema de campañas N°1 para Media Buyers, Freelancers y
          Emprendedores de Argentina y Latinoamérica.
          <br data-id="element-163" />
          <br data-id="element-164" />
          Porque hacer Meta Ads no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col items-center gap-2 text-sm text-gray-500 mb-8" data-id="element-165">
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-green-400 transition-colors" data-id="element-166">
            📧 soporte.tumanualdigital@gmail.com
          </a>
          <span className="hover:text-green-400 transition-colors cursor-pointer" data-id="element-167">
            📲 @tu.manualdigital
          </span>
          <a href="https://www.tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors" data-id="element-168">
            🌐 www.tumanualdigital.com
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-2" data-id="element-169">
          <p data-id="element-170">
            © Tu Manual Digital™ 2025 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic" data-id="element-171">"La próxima campaña puede ser diferente." 🤖</p>
        </div>
      </div>
    </footer>;
}